module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-ccd443612e0b44d652802b4abce6565b.webp";